export const getDirection = (language) => {
  const rtlLanguages = ['he'];
  return rtlLanguages.includes(language) ? 'rtl' : 'ltr';
};
